import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import SEO from '../seo/SEO';

export default function withSEO(Component, metaMap, pattern, {
    robots = 'noindex, nofollow',
    type,            // optional: og:type
    image            // optional: og image
} = {}) {
    return function WrappedWithSEO(props) {
        const params = useParams();
        const { pathname } = useLocation();

        const entry = metaMap?.[pattern];
        const meta = typeof entry === 'function' ? entry(params) : entry || { title: '', description: '' };

        return (
            <>
                <SEO
                    title={meta.title}
                    description={meta.description}
                    robots={robots}
                    canonical={pathname}  // SEO.jsx will resolve to absolute via SITE_URL
                    type={type}
                    image={image}
                />
                <Component {...props} />
            </>
        );
    };
}
